export default __webpack_public_path__ + "static/media/metamask.4b1e294b.png";